export default "/_next/static/sounds/rory_voicemail-b03edbeb527088515e340083a08f041a.mp3";